<template>
  <!-- 登录、注册弹框 -->
  <div class="tankuang">
    <div class="mask"></div>
    <div class="login-pop">
      <div class="close-pop close">
        <img src="../../assets/img/close2.png" alt />
      </div>
      <div class="login-bg">
        <img src="../../assets/img/logo.png" />
      </div>
      <div class="account">
        <div class="form">
          <div class="row">
            <input
              type="text"
              :placeholder="loginType==1 ? '请输入手机号' : '请输入账户名'"
              class="phone-num"
              v-model="phone"
              v-on:input="getBtn"
            />
            <label>
              <i class="iconfont icon-guanbi-" @click="phoneNull"></i>
            </label>
          </div>
          <div class="row">
            <p v-if="isphone" class="warning">请输入6-16位数字字母组合密码!</p>
            <input
              :type="type"
              placeholder="请输入密码（6-16位）"
              class="pass"
              v-model="pass"
              v-on:input="getBtn"
            />
            <label :class="{'active':isActive}">
              <i class="iconfont icon-guanbi-" style="float:left" @click="passNull"></i>
              <span class="pass-show iconfont" @click="showPass"></span>
            </label>
          </div>
          <p v-if="ispassword" class="warning" v-text="isWrong"></p>
        </div>
        <p class="go-register" >
          <span @click="showReg" style="float: left;">还没有账号？去注册</span>
          <span @click="clickType" style="color: #2E8043;">{{loginType==1 ? '账号登录' : '手机登录'}}</span>
        </p>
        <div :class="['look-more']" @click="login" style="display:block!important">登录</div>
        <!-- <div class="other-media">
          社交账号登录
          <i class="iconfont icon-QQ"></i>
          <i class="iconfont icon-weixin"></i>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import common from "../../assets/comment/common.js";
import Vue from "vue";
import { setTimeout } from "timers";
import { stringify } from 'querystring';
Vue.prototype.common = common;
export default {
  data() {
    return {
      isActive: false,
      phone: "",
      pass: "",
      isphone: false,
      ispassword: false,
      isWrong: "请输入6-16位数字字母组合密码!",
      type: "password",
	  loginType:1,
      a: 0
    };
  },
  methods: {
    showReg() {
      this.$parent.name = "register";
    },
    // showPassWord() {
    //   this.$parent.name = "changePassword";
    // },
    showPass() {
      this.isActive = !this.isActive;
    },
    showPass() {
      this.isActive = !this.isActive;
      if (this.isActive == true) {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    getBtn() {
      if (this.phone != "" && this.pass != "") {
        this.a = 1;
      } else {
        this.a = 0;
      }
    },
    phoneNull() {
      this.phone = "";
    },
    passNull() {
      this.pass = "";
    },
	clickType(){
		this.phone = "";
		this.pass = "";
		this.loginType = this.loginType==1 ? 2 : 1
	},
    login() {
      if (this.phone == "" && this.pass == "") {
        this.isphone = true;
        this.ispassword = true;
      }
      if (!this.common.verifyMobile(this.phone) && this.loginType==1) {
        this.isphone = true;
        return false;
      } else {
        this.isphone = false;
      }
      if (!this.common.verifyPass(this.pass)) {
        this.ispassword = true;
        return false;
      } else {
        this.ispassword = false;
      }
	  var url = this.loginType==1 ? '/api/user/003-login' : '/api/pcManager/002-login'
	  var data = this.loginType==1 ? {phone:this.phone,loginPwd:this.pass} : {nickName:this.phone,loginPwd:this.pass} 
      this.$http
        .get(url, {
          params: data
        })
        .then(res => {
           console.log(res, "获取认证状态");
          if (res.status == 200 && res.data.code == 0) {
            this.$message("登录成功");
            var data = res.data.rows[0];
            this.role = res.data.rows[0].role;
            this.getStatus(data.id,data.phone,data.token,data.role)
			if(data.role!=1){
				this.$router.push({ path: "/iPage_sub" });
			}
			if(this.loginType!=1 && data.phone==''){
				this.$parent.bindPhoneShow();
			}
          }
          if (res.status == 200 && res.data.code == 1002) {
            this.ispassword = true;
            this.isWrong = "用户名或密码错误";
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStatus( id,phone,token,role ){
      // console.log(this.$store.state.userInfo.status)
      this.$http
        .get("/api/media/007--accountSetting", {
          params: {
            token: token,
          }
        })
        .then(res => {
          console.log(res, "获取认证状态");
          if ( res.data.code == 0) {
            var checkStatus,checkRemark;
            if(res.data.rows== ''){
              checkStatus = null ;
              checkRemark = null ;
            }else{
              checkStatus = res.data.rows[0].status;
              checkRemark = res.data.rows[0].remark
            }
            var userInfo = {
              id: id,
              phone: phone,
              token: token,
              role: role,
              status: checkStatus,
              remark: checkRemark
            };
            this.$store.commit("setUserInfo", userInfo);
            this.$emit("childUserInfo", {
              id: userInfo.id,
              phone: userInfo.phone,
              token: userInfo.token,
              role:  userInfo.role,
              status: userInfo.status,
              remark: userInfo.remark

            });
             if ( res.data.rows[0].status == 3) {
              this.$store.commit("userPerson", { a: false });
              this.$parent.$parent.ki = 0;
            } else {
              this.$store.commit("userPerson", { a: true });
              this.$parent.$parent.k = 0;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    const self = this;
    // 关闭页面
    $(".close-pop").click(function() {
      self.$parent.$data.panelModal = false;
    });
  }
};
</script>
<style scoped>
.look-more {
  cursor: pointer;
}
.look-more.active {
  border: none;
  background: #ededed;
  color: #fff;
  /* pointer-events: none;
  cursor: not-allowed; */
}
</style>